export default function Marquee({ items }) {
  const Row = ({ hidden = false }) => (
    <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
      {items.map((it, i) => (
        <span key={i} className="flex items-center">
          <span className="whitespace-nowrap px-7 text-[13px] font-medium uppercase tracking-[0.18em] text-ink2">
            {it}
          </span>
          <span className="h-1.5 w-1.5 rounded-full bg-brand/60" />
        </span>
      ))}
    </div>
  );
  return (
    <div className="marquee overflow-hidden border-y border-line bg-white py-4" data-testid="marquee-band">
      <div className="marquee-track">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
